import { useMemo } from "react"
import { useContentSetsMetadata } from "resources/content-sets"
import { OK, type DataStatus } from "helpers/data-statuses"
import type { ContentSetMetadata } from "../content-set/types"
import type { CustomGraphFamilyContext } from "./family"

// Shared by the chart body and the metrics selector so content-set loading/error/found-null semantics stay identical between them.
export function useCustomGraphContentSetMetadata(familyContext: CustomGraphFamilyContext): {
  contentSetMetadata: ContentSetMetadata | null | undefined
  contentSetsStatus: DataStatus
} {
  const [contentSetsMetadata, contentSetsStatus] = useContentSetsMetadata() as [ContentSetMetadata[] | null, DataStatus]

  const contentSetMetadata = useMemo(() => {
    if (familyContext.family !== "content-set") return undefined
    if (contentSetsStatus !== OK) return undefined
    return contentSetsMetadata?.find(cs => cs.id === familyContext.contentSetId) ?? null
  }, [familyContext, contentSetsMetadata, contentSetsStatus])

  return { contentSetMetadata, contentSetsStatus }
}
